<div class="marketing-container">
  <div class="marketing-header">
    <img src="/assets/rc-logo.png" />
  </div>
  <div class="marketing-content">
    <div class="marketing-heading">
      {{ constants.heading }}
    </div>
    <div class="marketing-panels">
      <div class="m-panel">
        <div class="callout-block"></div>
        <div class="content-block">
          <div class="question-block">{{ constants.panelQuestion }}</div>
          <div class="text-block">
            {{ constants.panelText }}
          </div>
        </div>
        <thera-button
            [config]="{ variant: buttonVariant.PRIMARY, text: constants.learnMore }"
            (click)="learnMore()"
            class="learn-more"
        ></thera-button>
      </div>
      <div class="m-panel">
        <img src="/assets/marketing-image.png" />
      </div>
    </div>
  </div>
</div>
